<template>
  <div id="map" class="events-map"></div>
</template>

<script>
import * as L from "../../node_modules/leaflet/dist/leaflet-src";

export default {
  name: "MusicMap",
  props: ["modalEvent", "lat", "lng", "zoom"],
  data: function() {
    return {
      cachedLat: undefined,
      cachedLng: undefined,
      cachedMap: undefined,
      latitude: 0,
      longitude: 0,
      cachedZoom: undefined,
      city: undefined
    };
  },

  // mounted() {
  //   if (this.cachedMap) {
  //     this.cachedMap.remove();
  //   }
  //   // set up new api that scrapes google maps when this component is mounted and finds the lat/lng
  //   //use MusicMap component to map the venue
  //   let googleMap = new google.maps.Map(document.getElementById("map"));
  //   const request = {
  //     query: `${this.modalEvent.venue_name}, ${this.modalEvent.address[1]}`,
  //     fields: ["name", "geometry"]
  //   };

  //   let service = new google.maps.places.PlacesService(googleMap);
  //   service.findPlaceFromQuery(request, (results, status) => {
  //     const lat = results[0].geometry.location.lat();
  //     const lng = results[0].geometry.location.lng();
  //     this.cachedLat = lat;
  //     this.cachedLng = lng;
  //     let map;
  //     this.zoom = this.zoom || 10;
  //     map = L.map("map");
  //     const icon = L.icon({
  //       iconUrl: "/genre_icons/marker_sm.svg"
  //     });
  //     const popup = L.popup({ autoPan: false });
  //     const address = this.modalEvent.address[0].split(", ");
  //     popup.setContent(
  //       `<div class="popup-artist-name">${address[0]}<br>${address[1]}, ${
  //         this.modalEvent.address[1]
  //       }</div>`
  //     );
  //     const marker = L.marker([lat, lng], {
  //       icon
  //     }).bindPopup(popup);

  //     map.setView([lat, lng], this.zoom, { animate: true });

  //     L.tileLayer(
  //       "http://c.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.{ext}",
  //       {
  //         attribution:
  //           'Map tiles by <a href="https://github.com/CartoDB/basemap-styles">Carto Dn</a>',
  //         subdomains: "abcd",
  //         minZoom: 0,
  //         maxZoom: 20,
  //         fadeAnimation: false,
  //         ext: "png"
  //       }
  //     ).addTo(map);
  //     map.scrollWheelZoom.disable();
  //     map.zoomControl.options.position = "topright";
  //     marker.addTo(map);
  //     map.cachedLat = lat;
  //     map.cachedLng = lng;
  //     this.cachedMap = map;
  //   });
  // }

  mounted() {
    const lat = this.modalEvent.location.geo.latitude;
    const lng = this.modalEvent.location.geo.longitude;
    const city = this.modalEvent.location.address.addressLocality;
    const venue = this.modalEvent.location.name;
    this.cachedLat = lat;
    this.cachedLng = lng;
    if (this.cachedMap) {
      this.cachedMap.remove();
    }
    let map;
    this.zoom = this.zoom || 10;
    map = L.map("map");
    const icon = L.icon({
      iconUrl: "/genre_icons/marker_sm.svg"
    });
    const popup = L.popup({ autoPan: false });
    popup.setContent(
      `${this.modalEvent.location.name}<br>${
        this.modalEvent.location.address.streetAddress
      }<br>${city}, ${this.modalEvent.location.address.addressRegion}`
    );
    const marker = L.marker([lat, lng], {
      icon
    }).bindPopup(popup);

    map.setView([lat, lng], this.zoom, { animate: true });

    // var circle = L.circle([this.la, lng], 125, {
    //   color: "#c53526",
    //   fillColor: "#c53526",
    //   fillOpacity: 0.15
    // }).addTo(map);
    L.tileLayer("http://c.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.{ext}", {
      attribution:
        'Map tiles by <a href="https://github.com/CartoDB/basemap-styles">Carto Dn</a>',
      subdomains: "abcd",
      minZoom: 0,
      maxZoom: 20,
      fadeAnimation: false,
      ext: "png"
    }).addTo(map);
    map.scrollWheelZoom.disable();
    map.zoomControl.options.position = "topright";

    // let combinedLocations = sortMarkers(this.markers);

    // for (const p in combinedLocations) {
    //   if (
    //     combinedLocations &&
    //     combinedLocations[p] &&
    //     combinedLocations[p][0] &&
    //     combinedLocations[p][0].lat
    //   ) {
    //     const popup = L.popup({ autoPan: false });
    //     popup.setContent(`${combinedLocations[p].songsStr}`);

    //     markers.push(
    //       L.marker([p.split("_")[0], p.split("_")[1]], {
    //         icon
    //       }).bindPopup(popup)
    //     );
    //   }
    // }
    marker.addTo(map);
    map.cachedLat = map.getCenter().lat;
    map.cachedLng = map.getCenter().lng;
    this.cachedMap = map;
  }
};

function sortMarkers(data) {
  return data.reduce((accum, marker) => {
    if (marker) {
      const latLng = `${marker.lat}_${marker.lng}`;
      if (accum[latLng]) {
        accum[latLng].push(marker);
        accum[latLng].songsStr += `
        <div class="popup-artist-name">${marker.title}</div>
      `;
      } else {
        accum[latLng] = [];
        accum[latLng].songsStr = "";
        accum[latLng].songsStr += `
      <div class="popup-artist-name"${marker.title}</div>

    `;
        accum[latLng].push(marker);
      }
    }
    return accum;
  }, {});
}
</script>

<style>
#map.events-map {
  height: 50vh;
}
.leaflet-popup-content {
  max-height: 200px;
  overflow-y: auto;
  padding: 8px;
}

.leaflet-popup-content h4 {
  font-size: 0.9rem;
}

.popup-artist-name {
  padding-top: 8px;
}
</style>
